module.exports = __webpack_public_path__ + "static/media/c1_3.70583464.png";